import axios from 'axios'
import { BoxTruckDriverRoadDistance, NearbyBoxTruckDriver } from '@numeo/types-core'
import { getApiBaseUrlWithoutV1 } from '@/setup/SetupAxios'
import { fetchNearbyBoxTruckDrivers as fetchNearbyBoxTruckDriversRaw } from './boxTruckLoadsApi'

const NON_V1_BASE = getApiBaseUrlWithoutV1()

/** Normalizes the rollout alias while backend and frontend deployments overlap. */
export const fetchNearbyBoxTruckDrivers = async (...args: Parameters<typeof fetchNearbyBoxTruckDriversRaw>) => {
    const page = await fetchNearbyBoxTruckDriversRaw(...args)
    const withProximity = (driver: NearbyBoxTruckDriver): NearbyBoxTruckDriver => ({
        ...driver,
        proximityDistanceMi: driver.proximityDistanceMi ?? driver.distanceMi ?? null,
    })
    return {
        ...page,
        drivers: page.drivers.map(withProximity),
        nearest: page.nearest ? withProximity(page.nearest) : null,
    }
}

/** GraphHopper-only truck-road miles from one explicitly selected driver's current fix to the load pickup. */
export async function fetchNearbyDriverRoadDistance(
    driverId: string,
    pickup: { lat: number; lng: number },
    expectedFixAt: string | null,
    signal?: AbortSignal
): Promise<BoxTruckDriverRoadDistance> {
    try {
        const res = await axios.post<{ success: boolean; data: BoxTruckDriverRoadDistance }>(
            `/box-truck-loads/matching/nearby-drivers/${encodeURIComponent(driverId)}/road-distance/v1`,
            { pickupLat: pickup.lat, pickupLng: pickup.lng, ...(expectedFixAt ? { expectedFixAt } : {}) },
            { baseURL: NON_V1_BASE, signal }
        )
        return res.data.data
    } catch (error) {
        if (axios.isCancel(error)) throw error
        const serverMessage = axios.isAxiosError(error) ? (error.response?.data as { message?: string } | undefined)?.message : undefined
        throw new Error(serverMessage || 'Couldn’t calculate road miles.')
    }
}
